import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export interface TemplateReviewTakeoverContextState {
  isTemplateReviewTakeoverOpen: boolean;
  setIsTemplateReviewTakeoverOpen: (open: boolean) => void;
}

export const TemplateReviewTakeoverContext = createContext<TemplateReviewTakeoverContextState>({
  isTemplateReviewTakeoverOpen: false,
  setIsTemplateReviewTakeoverOpen: noop,
});

export const useTemplateReviewTakeoverContext = () => useContext(TemplateReviewTakeoverContext);
